export default {"src":"/_next/static/media/smart-pricing.28e1bfe5.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};